export default __webpack_public_path__ + "fbfa414cc65f37cc50d25bc0d6d1c7d1.svg";